import { createAction } from 'typesafe-actions';

import { TenantInfo, User } from '../types';

import { createActionTypePrefixFormat } from '@/state/common';

const typePrefixFormat = createActionTypePrefixFormat('user');

/* ------------- action auth ------------- */
export const setUser = createAction(typePrefixFormat('SET_USER'), (user: User) => ({
    user
}))();

export const setTenant = createAction(typePrefixFormat('SET_TENANT'), (tenant: TenantInfo | undefined) => ({
    tenant
}))();

export const setInvitationToken = createAction(typePrefixFormat('SET_INVITATION_TOKEN'), (token: string | null) => ({
    token
}))();

export const logout = createAction(typePrefixFormat('LOG_OUT'), () => ({}))();
